"use client"

import React from "react";
import cn from "classnames";
import {
    Card,
    Flex,
    Pagination,
    Spin,
    Typography
} from "antd";
import { useTranslations } from "next-intl";
import s from './history.module.scss';
import {
    useApi,
    useTempData
} from "@/lib/hook";
import { Table } from "@/theme/ui";

const { Text } = Typography;

const initFilterData = {
    page: 1,
}
export const WalletHistoryComponent = () => {
    const t = useTranslations('wallet');
    const {data: tempData, setTempData} = useTempData('wallets_history', initFilterData);
    const { data: data, isFetching } = useApi({
        route: {
            name: 'wallets.history',
        },
        data: {...tempData},
        setting: {
            select: (resp) => resp,
        },
    });

    const columns = [
        {
            title: t('table.date'),
            dataIndex: 'date',
            width: '200px',
            render: (item) => (
                <Text
                    className={s.grey}
                >
                    {item}
                </Text>
            )
        },
        {
            title: t('table.type'),
            dataIndex: 'type',
            width: '160px',
            render: (item) => (
                <Text
                    className={s.grey}
                >
                    {t(item)}
                </Text>
            )
        },
        {
            title: t('table.description'),
            dataIndex: 'description',
            width: '643px',
            render: (item) => (
                <Text
                    className={s.black}
                >
                    {item}
                </Text>
            )
        },
        {
            title: t('table.amount'),
            width: '100px',
            render: (item) => {
                let value = item.type === 'spent' ? '-' : '+';
                let currency = item.currency === "usd" ? "$" : "€";
                return (
                    <Text
                        className={cn({
                            [s.spent]: item.type === 'spent',
                            [s.admission]: item.type === 'admission'
                        })}
                    >
                        {`${value}${item.amount} ${currency}`}
                    </Text>
                )
            }
        },
    ];

    const onChangePage = (page) => {
        setTempData({
            ...tempData,
            page
        })
    }

    return (
        <Card
            className={'card_table'}
        >
            <Spin
                spinning={isFetching}
            >
                <Table
                    className={'wallets_history_table'}
                    dataSource={data?.data}
                    rowKey={'id'}
                    columns={columns}
                    expandable={{
                        showExpandColumn: false
                    }}
                />
                <Flex
                    className={s.pagination}
                    justify={'center'}
                >
                    {(data?.meta.pagination?.total_pages > 1)
                        ? <Pagination
                            onChange={onChangePage}
                            total={(data.meta.pagination?.total_pages) * 10}
                            current={data.meta.pagination?.current_page}
                        />
                        : null
                    }
                </Flex>
            </Spin>
        </Card>
    );
}